import React from 'react';
import { Grid, Row, Col } from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { injectIntl, FormattedMessage } from 'react-intl';
import cx from 'classnames';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { compose } from 'react-apollo';

import DashboardSideMenu from '../../components/Dashboard/DashboardSideMenu';
import messages from '../../locale/messages';

import AppStoreImage from '/public/siteImages/appStore.svg';
import PlayStoreImage from '/public/siteImages/playStore.svg';

import cs from '../../components/commonStyle.css';
import s from './ImageVerifyInfo.css';

class ImageVerifyInfo extends React.Component {
    static propTypes = {
        playStoreUrl: PropTypes.string,
        appStoreUrl: PropTypes.string
    };

    render() {
        const { playStoreUrl, appStoreUrl } = this.props;

        return (
            <Grid fluid className={'listingContainer verifyContainer'}>
                <h1 className='verifyTitle'>
                    <FormattedMessage {...messages.verifyInfo} />
                </h1>
                <div className='verifyButtonFlexContainer'>
                    <a href={appStoreUrl} target='_blank' rel="noopener noreferrer">
                        <img alt='App Store'  src={AppStoreImage} />
                    </a>
                    <a href={playStoreUrl} target='_blank' rel="noopener noreferrer">
                        <img alt='Play Store' src={PlayStoreImage} />
                    </a>
                </div>
            </Grid>
        );
    }
}

const mapState = state => ({
    playStoreUrl: state.siteSettings.data.playStoreUrl,
    appStoreUrl: state.siteSettings.data.appStoreUrl
});

export default compose(injectIntl, withStyles(s, cs), connect(mapState))(ImageVerifyInfo);